(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('profession', {
            parent: 'entity',
            url: '/profession?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.profession.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profession/professions.html',
                    controller: 'ProfessionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profession');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('profession-detail', {
            parent: 'entity',
            url: '/profession/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.profession.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profession/profession-detail.html',
                    controller: 'ProfessionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profession');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Profession', function($stateParams, Profession) {
                    return Profession.get({id : $stateParams.id});
                }]
            }
        })
        .state('profession.new', {
            parent: 'profession',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profession/profession-dialog.html',
                    controller: 'ProfessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('profession', null, { reload: true });
                }, function() {
                    $state.go('profession');
                });
            }]
        })
        .state('profession.edit', {
            parent: 'profession',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profession/profession-dialog.html',
                    controller: 'ProfessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Profession', function(Profession) {
                            return Profession.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('profession', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profession.delete', {
            parent: 'profession',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profession/profession-delete-dialog.html',
                    controller: 'ProfessionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Profession', function(Profession) {
                            return Profession.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('profession', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
